import AuthForm, { STATE_LOGIN } from '../components/AuthForm';
import React from 'react';
import { Card, Col, Row } from 'reactstrap';
import logo200Image from '../assets/img/logo/20200723_UnitySuiteSqLogo512.webp';
import loginimage from '../assets/img/login_image.jpeg';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import Typography from '../components/Typography';

class AuthPage extends React.Component {
  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  handleAuthState = authState => {
    if (authState === STATE_LOGIN) {
      this.props.history.push('/login');
    } else {
      this.props.history.push('/signup');
    }
  };

  handleLogoClick = () => {
    this.props.history.push('/');
  };

  forgotPassword = () => {
    this.props.history.push('/forgot-password');
  };

  render() {
    if (StorageService.getSession('user_info')) {
      return <Redirect to="/" />;
    }

    return (
      <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="container">
        <Row className="justify-content-center">
          <Col xs={12} lg={6}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <div className="ps-auth-image"> 
                <img src={loginimage} alt="Image" className="img-fluid" />
              </div>
            </div>
          </Col>
          <Col xs={12} lg={6}>
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <Card style={{ flex: 1 }} body className="card-1">
                <AuthForm
                  history={this.props.history}
                  authState={this.props.authState}
                  onChangeAuthState={this.handleAuthState}
                  onLogoClick={this.handleLogoClick}
                />
                <br></br>
              <h6>{this.isLogin && (<a className='link-1' href='#forgotpassword' onClick={this.forgotPassword}>Forgot Password?</a>)}</h6>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </div>
      // <div>
      //   <Row className="AuthPage ps-page-intro">
      //     <Col md={12} lg={4} className="d-none d-lg-block">
      //       <img
      //         src={logo200Image}
      //         style={{
      //           width: 150,
      //           cursor: 'pointer',
      //           display: 'block',
      //           margin: '0 auto',
      //         }}
      //         alt="logo"
      //       />
      //       <Typography className="mt-5 text-center h1 intro-title">
      //         UnitySuitePro
      //       </Typography>
      //       <p className="text-center version">
      //         {process.env.REACT_APP_VERSION}
      //       </p>
      //     </Col>
      //     <Col md={12} lg={8}>
      //       <div className="ps-auth-form">
      //         <Card body className="card-1">
      //           <AuthForm
      //             history={this.props.history}
      //             authState={this.props.authState}
      //             onChangeAuthState={this.handleAuthState}
      //             onLogoClick={this.handleLogoClick}
      //           />
      //         </Card>
      //         <h6 className="text-center form-bottom">
      //           {this.isLogin && (
      //             <a
      //               className="link-1"
      //               href="#forgotpassword"
      //               onClick={this.forgotPassword}
      //             >
      //               Forgot password?
      //             </a>
      //           )}
      //         </h6>
      //       </div>
      //     </Col>
      //   </Row>
      // </div>
      
    );
  }
}

export default AuthPage;
